import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { faro } from '../config/faro';

const ROUTE_NAMES: Record<string, string> = {
  '/': 'Dashboard',
  '/appointments': 'Appointments',
  '/clients': 'Clients',
  '/patients': 'Horses',
  '/clinical-records': 'Clinical Records',
  '/reports': 'Reports',
  '/billing': 'Financial',
  '/barn-operations': 'Barn Operations',
  '/inventory': 'Inventory',
  '/settings': 'Settings',
  '/login': 'Login',
  '/signup': 'Signup',
  '/setup': 'Account Setup',
  '/reset-password': 'Reset Password',
  '/paywall': 'Paywall',
  '/subscription/success': 'Subscription Success',
};

function resolveRouteName(pathname: string): string {
  if (ROUTE_NAMES[pathname]) return ROUTE_NAMES[pathname];

  if (pathname.startsWith('/clinical-records/')) return 'Clinical Records (Patient)';

  return pathname;
}

export function useFaroRouteTracking() {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!faro || location.pathname === prevPathRef.current) return;

    const viewName = resolveRouteName(location.pathname);
    faro.api.setView({ name: viewName });
    faro.api.pushEvent('page_view', {
      path: location.pathname,
      view: viewName,
    });

    prevPathRef.current = location.pathname;
  }, [location.pathname]);
}
